import React from 'react';
import PropTypes from 'prop-types';

const MembershipServiceContext = React.createContext(null);

export const MembershipProvider = ({ children }) => {
	const [membershipService, setMembershipService] = React.useState(null);

	return (
		<MembershipServiceContext.Provider
			value={{ membershipService, setMembershipService }}
		>
			{children}
		</MembershipServiceContext.Provider>
	);
};

MembershipProvider.propTypes = {
	children: PropTypes.node.isRequired
};

export const useMembership = () => React.useContext(MembershipServiceContext);
